import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { translateGet } from "../../modules/translate";

class Translate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            translateData: null,
            translatedWord: null,
        }
    }

    componentDidUpdate(prevProps) {
      if (prevProps.id !== this.props.id) {
        this.searchTranslation(this.props.id);
      }
    }

    componentDidMount() {
        // console.log(this.props.id)
        if (!this.props.translateData) {
            this.props.translateGet().then(
                () => {
                    if (this.props.translateData) {
                        this.setState({ translateData: this.props.translateData },()=>this.searchTranslation(this.props.id));
                        // console.log(this.props.translateData);
                    }
                }
            )
        } else {
            if(!this.state.translateData){
                // console.log("update")
                if (this.props.translateData) {
                    this.setState({ translateData: this.props.translateData },()=>this.searchTranslation(this.props.id));
                    // console.log(this.state.translateData);
                }
            }
        }
    }

    searchTranslation = (id) => {
        let newtranslatedWord = null
        if (this.state.translateData) {
            // console.log(this.state.translateData)
            newtranslatedWord = this.state.translateData.results.find(
                (value) => {
                    // console.log(value)
                    return (value.translationId == id)
                }
            )
        }
        // console.log(newtranslatedWord)
        this.setState({ translatedWord: newtranslatedWord })
    }

    render() {
        const { translateData } = this.state
        return (

            (this.state.translatedWord) ?
                <span>{this.state.translatedWord[this.props.language]}</span>
                : 
                null


        )
    }
}

const mapStateToProps = state => ({
    language: state.mainpage.language,
    translateData: state.translate.translateData
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            translateGet
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(Translate);
